import { nanoid } from "nanoid";
import { clsx, type ClassValue } from "clsx";
import { DMEData, iterateBlockList } from "dmeditor";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

//convert old to new
export const convertObject = (data: DMEData.Block[]) => {
  iterateBlockList(data as any, (blockitem: any) => {
    if (blockitem.type === "hero-text" && Array.isArray(blockitem.children)) {
      const children = blockitem.children;
      if (children[0] && children[1]) {
        blockitem.children = { hero: children[0], list: children[1] } as any;
      } else if (children.length === 1) {
        if (children[0].type === "list") {
          blockitem.children = {
            hero: {
              type: "image",
              data: { src: "", settings: {} },
              isEmbed: true,
            },
            list: children[0],
          } as any;
        } else if (children[0].type === "image") {
          blockitem.children = {
            hero: children[0],
            list: { type: "list", data: {}, children: [], isEmbed: true },
          };
        }
      } else {
        blockitem.children = {
          hero: {
            type: "image",
            data: { src: "", settings: {} },
            isEmbed: true,
          },
          list: { type: "list", data: {}, children: [], isEmbed: true },
        } as any;
      }
    }

    if (
      blockitem &&
      blockitem.type === "layout-2columns" &&
      Array.isArray(blockitem.children)
    ) {
      const children = blockitem.children;
      if (children[0] && children[1]) {
        blockitem.children = {
          column1: {
            id: nanoid(),
            type: "list",
            data: {},
            ...children[0],
          },
          column2: { id: nanoid(), type: "list", data: {}, ...children[1] },
        } as any;
      }
    }

    if (
      blockitem &&
      blockitem.type === "layout-3columns" &&
      Array.isArray(blockitem.children)
    ) {
      const children = blockitem.children;
      if (children[0] && children[1] && children[2]) {
        blockitem.children = {
          column1: { id: nanoid(), type: "list", data: {}, ...children[0] },
          column2: { id: nanoid(), type: "list", data: {}, ...children[1] },
          column3: { id: nanoid(), type: "list", data: {}, ...children[2] },
        } as any;
      }
    }
  });

  return data;
};
